module.exports = __webpack_public_path__ + "assets/music/rock/Incub by byrum.ogg";